import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_global/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/ColumnImageSection/ColumnImageSection.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/Description/Description.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_product/HeroPhysical/HeroPhysical.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_product/HeroVoucher/HeroVoucher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_product/Informations/Informations.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/Parameters/Parameters.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/OrderedList/OrderedList.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_product/Reviews/Reviews.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/Standout/Standout.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/TextSection/TextSection.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/components/_product/UnorderedList/UnorderedList.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
